import '../css/app.css';

// Alpine
import './alpine/index.js';

// Vendor
import './vendor/swiper.js';
import './vendor/prism.js';
import './vendor/aos.js';
import './vendor/medium-zoom.js';

// Components
import './components/fanuc-product-renaming';
import './components/wistia-player-controller';
import './components/wistia-cover-loader';
import './components/resize-transition-guard';
import './components/attribution';

// Cache debug tool stays out of the main bundle — loads on demand via #cache-debug
const loadCacheDebug = () => {
  if (window.location.hash.split('#').includes('cache-debug'))
    import('./components/cacheDebug');
};
loadCacheDebug();
window.addEventListener('hashchange', loadCacheDebug);

// Add static assets to production build on vite
import.meta.glob(['../images/**', '!../**/*.{md,csv}']);
